<!-- <template>
  <div
    id="review"
    class="tab-pane review-more fade"
    v-if="product != null && product.description != null"
    :class="activeTab === 'review' ? 'in active show' : ''"
  >
    <p
      class="fontsize-small text-color-666 text-justify line-height2 p-3"
      v-html="product.description"
    ></p>
    
    <button @click="showBox" class="more" id="moreBtn">
      {{ titleBtn }}
    </button>
  </div>
</template>
<script>
export default {
  props: ["activeTab", "product"],
  data() {
    return {
      titleBtn: "مشاهده بیشتر",
    };
  },
  methods: {
    showBox() {
      console.log(document.querySelector("#review > p"), "aaaaaaaaaaaaaaaaaa");
      document.querySelector(".review-more").classList.toggle("open");
    },
   
  },
  mounted() {},
};
</script>
<style scoped>
.review-more {
  height: 400px;
  overflow: hidden;
  position: relative;
  transition: height 1s;
}
.review-more.open {
  height: fit-content;
  overflow: hidden;
  position: relative;
}
.more {
  position: absolute;
  bottom: 0;
}
</style>
<style>
@media (max-width: 768px) {
  div#review img {
    width: 100% !important;
    height: auto !important;
  }
}
</style> -->
<template>
  <div
    id="review"
    class="tab-pane review-more fade"
    v-if="product != null && product.description != null"
    :class="activeTab === 'review' ? 'in active show' : ''"
    ref="reviewBox"
  >
    <p
      class="fontsize-small text-color-666 text-justify line-height2 p-3"
      v-html="product.description"
    ></p>

    <button @click="showBox" class="more" id="moreBtn" ref="moreBtn">
      {{ titleBtn }}
    </button>
    <span ref="scrollBtn"> </span>
  </div>
</template>

<script>
export default {
  props: ["activeTab", "product"],
  data() {
    return {
      titleBtn: "مشاهده بیشتر",
      isOpen: false,
    };
  },
  methods: {
    showBox() {
      const box = this.$refs.reviewBox;
      const btn = document.getElementById("review");
      const scrollBtn = this.$refs.scrollBtn;

      if (!box) return;

      if (!this.isOpen) {
        // 🚀 باز کردن باکس
        const fullHeight = box.scrollHeight;
        box.style.height = fullHeight + "px";
        this.titleBtn = "بستن";
      } else {
        // 🔒 بستن باکس
        box.style.height = "400px";
        this.titleBtn = "مشاهده بیشتر";

        // ✨ اسکرول نرم تا جای دکمه
        // با کمی تاخیر تا Transition کامل شود
        setTimeout(() => {
          btn.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 600); // تاخیر هماهنگ با transition
      }

      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
.review-more {
  position: relative;
}
.more {
  display: none;
}

@media (max-width: 768px) {
  .review-more {
    height: 400px;
    overflow: hidden;
    position: relative;
    transition: height 0.8s ease;
  }
  .more {
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: var(--color-theme);
    padding: 4px 20px;
    border-radius: 8px;
    color: white;
    font-size: 12px;
  }
}
</style>

<style>
@media (max-width: 768px) {
  div#review img {
    width: 100% !important;
    height: auto !important;
  }
}
</style>
